<div class="ml-5">
  <p class="titre1 m-4">
    {{ 'SELECTION_ENTITE' | translate }}
    <mat-icon
    class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">dashboard</mat-icon>
  </p>
  <div class="container mx-auto">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      @for (entiteUtilisateur of entiteUtilisateurs; track entiteUtilisateur) {
        <app-selection-entite-card
        [entiteUtilisateur]="entiteUtilisateur" (cardClick)="onCardClick($event)"></app-selection-entite-card>
      }
    </div>
  </div>
</div>
